<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title>Synthèse Entreprise  <SimpleChips
                icon="mdi-alpha-u-circle-outline"
                v-bind:value="administratif_donnes.etatAdministratifUniteLegale.valeur"
            ></SimpleChips></v-card-title>



          <PictoItem :data="age_ul"/>
          <PictoItem :data="evenements"/>
          <PictoItem :data="effectif_evol"/>
          <PictoItem :data="effectif_ul"/>
          <PictoItem :data="ca"/>
          <PictoItem :data="ca_evol"/>
          <PictoItem :data="bilanINPI"/>
          <PictoItem :data="etablissements"/>
          <PictoItem :data="flotte"/>
          <PictoItem :data="actu_neg"/>
          <PictoItem :data="ctx_client_siren"/>
          <PictoItem :data="actu_pos"/>
          <v-divider
          ></v-divider>
            <v-card-title>Synthèse Etablissement
          <SimpleChips
                icon="mdi-alpha-e-circle-outline"
                v-bind:value="administratif_donnes.etatAdministratifEtablissement.valeur"
            ></SimpleChips>
            </v-card-title>
          <PictoItem :data="age_etab"/>
          <PictoItem :data="effectif_etab"/>
          <PictoItem :data="ctx_client_siret"/>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PictoItem from "@/components/layout/PictoItem.vue";
import SimpleChips from "@/components/layout/SimpleChips.vue";

export default {
  name: "Synthese",
  props: ["etablissement"],
  components: {
    PictoItem,SimpleChips
  },

  computed: {
    bilanINPI: function () {
      try {
        var bilan = this.$store.getters.BilanInpiList

        var len = 0
        for (var b of bilan) {
          if (b.path !== 'Error' && b.path !== 'Missing')
            len++
        }
        if (len <= 0) {
          return null
        }

        var s = 's'
        if (len == 1)
          s = ''

        return {
          "id": "blocbilans",
          "tooltip": len + " bilan"+s+" disponible"+s,
          "icon": "fas fa-file-pdf",
          "color": "blue",
          "text": len + " bilan"+s+" disponible"+s,
        }
      } catch (error) {
        return null
      }
    },
    ca_evol : function () {
      try {
        var ca = this.$store.getters.getbloc("finance", "donnees", "bilanGratuit")
        if (ca != null && ca.valeur != null & ca.valeur.length > 1) {

          if (ca.valeur[1]['chiffredaffaires'] == null || ca.valeur[0]['chiffredaffaires'] == null)
            return null

          if (ca.valeur[0]['annee'] < 2019)
            return null

          var cadataLast = ca.valeur[0]['chiffredaffaires']
          var cadataBefore = ca.valeur[1]['chiffredaffaires']

          var taux = (cadataLast-cadataBefore)/cadataBefore*100
          taux = taux.toFixed(1)

          return {
            "id": "blocca",
            "tooltip": "Chiffre d'affaire " + taux + " %",
            "icon": (taux >= 0 ? "fas fa-arrow-up" : "fas fa-arrow-down"),
            "color": (taux >= 0 ? "blue" : "red"),
            "text": "CA : " + taux + " %",
          }
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    ca: function () {
      try {
        var ca = this.$store.getters.getbloc("finance", "donnees", "bilanGratuit")
        if (ca != null && ca.valeur != null & ca.valeur.length > 0) {
          var cadata = ca.valeur[0]

          return {
            "id": "blocca",
            "tooltip": "Chiffre d'affaire " + cadata["annee"],
            "icon": "mdi-currency-eur",
            "color": (cadata["annee"] >= 2019 ? "blue" : "grey"),
            "text": "CA : " + cadata["chiffredaffaires"].toLocaleString() + " €" + " (" + cadata["annee"] + ")",
          }
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },

    capital: function () {
      var capital = this.$store.getters.getbloc("finance", "donnees", "capitalSocialGratuit")
      if (capital != null) {
        return {
          "id": "blocfinance",
          "tooltip": "Capital Social",
          "icon": "euro_symbol",
          "color": "blue",
          "text": "Capital : " +capital.libelle
        }
      } else {
        return null
      }
    },
    flotte: function () {
      var flotte = this.$store.getters.getbloc("equipement", "donnees", "flotte")
      if (flotte != null) {
        return {
          "id": "blocflotte",
          "tooltip": "Flotte automobile",
          "icon": "mdi-car",
          "color": (flotte.valeur!=null && flotte.valeur.length>0 ? "blue" : "grey"),
          "text": flotte.libelle
        }
      } else {
        return null
      }
    },
     actu_pos: function () {
      var actu = this.$store.getters.getbloc("info", "indicateurs", "actu_positive")
      if (actu != null && actu.valeur!=null && actu.valeur.length>0) {
        return {
          "id": "actup",
          "tooltip": "Actualité positive (attention aux faux positifs)",
          "icon": "mdi-library",
          "color": "green",
          "text": actu.libelle
        }
      } else {
        return null
      }
    },
    actu_neg: function () {
      var actu = this.$store.getters.getbloc("info", "indicateurs", "actu_negative")
      if (actu != null && actu.valeur!=null && actu.valeur.length>0) {
        return {
          "id": "actun",
          "tooltip": "Actualité négative (attention aux faux positifs)",
          "icon": "mdi-library",
          "color": "red",
          "text": actu.libelle
        }
      } else {
        return null
      }
    },

    effectif_ul: function () {

      var effectifIL = this.$store.getters.getbloc("administratif", "indicateurs", "effectifsUniteLegale-infolegale")
      if (effectifIL != null && effectifIL.libelle !=null &&  effectifIL.libelle !="" ) {
        return {
          "id": "blocunite",
          "tooltip": "Effectif Entreprise ",
          "icon": "groups",
          "color": "blue",
          "text": effectifIL.libelle + " salariés"
        }
      } else {
        var effectif = this.$store.getters.getbloc("administratif", "indicateurs", "trancheEffectifsUniteLegale")
        var effectif_annee = this.$store.getters.getbloc("administratif", "indicateurs", "anneeEffectifsUniteLegale", "")
        if (effectif_annee != "") effectif_annee = " (" + effectif_annee.libelle + ")"

        if (effectif != null) {
          if (effectif.valeur == "NN" || effectif.valeur==null ||  effectif.libelle =="") {
            return {
              "id": "blocunite",
              "tooltip": "Effectif Entreprise : Etablissement non employeur ou effectif inconnu",
              "icon": "groups",
              "color": "grey",
              "text": ""
            }
          } else {

            return {
              "id": "blocunite",
              "tooltip": "Effectif Entreprise ",
              "icon": "groups",
              "color": "blue",
              "text": effectif.libelle + effectif_annee
            }
          }
        } else {
          return null
        }
      }
    },
    etoiles: function () {
      var ctxClient = this.$store.getters.getbloc("environnement", "donnees", "contexte_client")
      if (this.$store.state.userLea&&process.env.VUE_APP_ENV!='DAAS') {
        return null
      }
      if (ctxClient === null){
        return null
      }
      if (ctxClient.valeur === null){
        return null
      }
      return {
          "etoile_siret": ctxClient.valeur.etoile_siret,
          "etoile_siren": ctxClient.valeur.etoile_siren
        }
    },

    ctx_client_siret: function () {

      var ctxClientSiret = this.$store.getters.getbloc("environnement", "donnees", "contexte_client_siret")
      if (this.$store.state.userLea&&process.env.VUE_APP_ENV!='DAAS') {
        return null
      }
      if (ctxClientSiret === null){
        return null
      }
      if (ctxClientSiret.valeur === null){
        return null
      }
      return {
          "id": "bloc-contexte-clients-siret",
          "tooltip": "Contexte Client",
          "icon": "mdi-account-check-outline",
          "color": (ctxClientSiret.libelle == "ex client" ? "grey" : "blue"),
          "text": ctxClientSiret.libelle
        }
    },
    ctx_client_siren: function () {
      var ctxClientSiren = this.$store.getters.getbloc("environnement", "donnees", "contexte_client_siren")
      if (this.$store.state.userLea&&process.env.VUE_APP_ENV!='DAAS') {
        return null
      }
      if (ctxClientSiren === null){
        return null
      }
      if (ctxClientSiren.valeur === null){
        return null
      }
      return {
          "id": "bloc-contexte-clients-siren",
          "tooltip": "Contexte Client",
          "icon": "mdi-account-check-outline",
          "color": (ctxClientSiren.libelle == "ex client" ? "grey" : "blue"),
          "text": ctxClientSiren.libelle
        }
    },
    effectif_evol: function () {
      var effectifEvol = this.$store.getters.getbloc("administratif", "donnees", "evolutionEffectif")
      if (effectifEvol === null || effectifEvol.length < 2)
        return null
      var arr = effectifEvol['valeur']

      var cleanedEffectif = []
      for (var idx in arr) {
        if (arr[idx]['effectif'] != null) {
          cleanedEffectif.push(arr[idx])
        }
      }
      arr = cleanedEffectif

      if (arr.length < 2) {
        return null
      }

      // Effectif des 2 dernières années
      var lastYearIdx = 0
      var yearBeforeIdx = 0


      for (idx in arr) {
        if (arr[lastYearIdx]['annee'] < arr[idx]['annee'])
          lastYearIdx = idx
      }
      for (idx in arr) {
        if (arr[yearBeforeIdx]['annee'] < arr[idx]['annee'] && arr[idx]['annee'] < arr[lastYearIdx]['annee'])
          yearBeforeIdx = idx
      }

      var thisYear = new Date().getFullYear()
      if (arr[lastYearIdx]['annee'] < thisYear - 3) {
        return null
      }

      var text = "Effectif ("+arr[lastYearIdx]['annee']+")"
      var color = "blue"
      if (2019 - arr[lastYearIdx]['annee'] >= 0) {
        color = "grey"
      }

      var icon = "fas fa-arrow-right"
      if (arr.length > 1) {
        if (arr[lastYearIdx]['effectif'] > arr[yearBeforeIdx]['effectif'])
          icon = "fas fa-arrow-up"
        if (arr[lastYearIdx]['effectif'] < arr[yearBeforeIdx]['effectif'])
          icon = "fas fa-arrow-down"
      }

      if (effectifEvol != null && effectifEvol.valeur !=null &&  effectifEvol.valeur !="" ) {
        return {
          "id": "blocEvolutionEffectif",
          "tooltip": "Évolution Effectif",
          "icon": icon,
          "color": color,
          "text": text,
        }
      }
      return null
    },



    evenements : function() {
      var list = this.$store.getters.getbloc("evenements", "donnees", "liste_des_annonces_legales", null, "valeur")
      var listbodacc = this.$store.getters.getbloc("evenements", "donnees", "bodacc", null, "valeur")

      var nb=0
      var nbalertes = 0
      if (list != null )  {
        const result = list.filter(etab => etab.alerte);
        nbalertes = result.length
        nb = list.length

      }

      if (listbodacc != null )  {
        const result = listbodacc.filter(etab => etab.alerte);
        nbalertes = Math.max(nbalertes, result.length)
        nb = Math.max( nbalertes, listbodacc.length)

      }


      return {
        "id": "blocevenements",
        "tooltip": "Annonces légales",
        "icon": "mdi-bullhorn",
        "color": (nbalertes > 0 ? "red" : nb>0 ? "blue" : "grey"),
        "text": (nbalertes > 0 ? nbalertes+" alertes" : nb>0 ? nb+ " annonces" : ""),
      }
    },
    effectif_etab: function () {
      var effectif = this.$store.getters.getbloc("administratif", "indicateurs", "trancheEffectifsEtablissement")
      var effectif_annee = this.$store.getters.getbloc("administratif", "indicateurs", "anneeEffectifsEtablissement", "")
      if (effectif_annee != "") effectif_annee = " (" + effectif_annee.libelle + ")"
      if (effectif != null) {
        if (effectif.valeur === "NN" ) {
          return {
            "id": "blocetab",
            "tooltip": "Effectif Etablissement : Etablissement non employeur",
            "icon": "groups",
            "color": "grey",
            "text": ""
          }
        } if (effectif.valeur =="" ) {
           return {
             "id": "blocetab",
             "tooltip": "Effectif Etablissement : inconnu",
             "icon": "groups",
             "color": "grey",
             "text": ""
           }
        } else {
          if (effectif.valeur == null ||   effectif.valeur =="") {
             return {
              "id": "blocetab",
              "tooltip": "Effectif Etablissement ",
              "icon": "engineering",
              "color": "grey",
              "text": "Inconnu"
            }
          } else {
            return {
              "id": "blocetab",
              "tooltip": "Effectif Etablissement ",
              "icon": "engineering",
              "color": "blue",
              "text": effectif.libelle + effectif_annee
            }
          }
        }
      } else {
        return null
      }
    },
    etablissements: function () {
      var etabs = this.$store.getters.getbloc("environnement", "donnees", "listeEtablissements")
      var nb = 0
      if (etabs != null && etabs.valeur!=null)  {
        const result = etabs.valeur.filter(etab => etab.etatAdministratifEtablissement =="A");
        nb = result.length
      }

      return {
        "id": "blocenvironnement",
        "tooltip": "Nombre d'établissements",
        "icon": "mdi-office-building-outline",
        "color": (nb == 0 ? "grey" : "blue"),
        "text": nb+" étabs"
      }


    },
    age_ul: function() {
      var age = this.$store.getters.getbloc("administratif", "donnees", "ancienneteUniteLegale")
      if (age != null && age.valeur!=null) {

        var nb = age.valeur
        return {
          "id": "blocunite",
          "tooltip": "Ancienneté Entreprise",
          "icon": "mdi-cake-variant",
          "color": (nb <2 ? "red" : nb <5 ? "yellow" : "green"),
          "text": age.libelle
        }
      } else {
        return null
      }
    },
    age_etab: function() {
      var age = this.$store.getters.getbloc("administratif", "donnees", "ancienneteEtablissement")
      if (age != null && age.valeur!=null) {

        var nb = age.valeur
        return {
          "id": "blocetab",
          "tooltip": "Ancienneté etablissement",
          "icon": "mdi-cake-variant",
          "color": (nb <2 ? "red" : nb <5 ? "yellow" : "green"),
          "text": age.libelle
        }
      } else {
        return null
      }
    },

    administratif_donnes: function () {
           return this.$store.getters.getbloc("administratif", "donnees")


    },



  },

  methods: {

  },
};
</script>
